import { type RefObject, useEffect, useRef } from 'react'

// Follows growing content (a streamed reply) only while the reader is at the
// bottom. Any upward scroll pauses following until they return to within
// `threshold` px of the bottom, or `restartKey` changes (a new question).
export function useStickToBottom(
  ref: RefObject<HTMLElement | null>,
  content: unknown,
  restartKey: unknown,
  threshold = 48,
) {
  const stick = useRef(true)
  const lastTop = useRef(0)

  useEffect(() => {
    stick.current = true
  }, [restartKey])

  useEffect(() => {
    const el = ref.current
    if (content && el && stick.current) el.scrollTop = el.scrollHeight
  }, [content])

  return function onScroll() {
    const el = ref.current
    if (!el) return
    // Growth below never lowers scrollTop, so a drop means the user scrolled up
    // (even a few px, which a pure distance check would snap straight back).
    if (el.scrollTop < lastTop.current - 1) stick.current = false
    else if (el.scrollHeight - el.scrollTop - el.clientHeight < threshold) stick.current = true
    lastTop.current = el.scrollTop
  }
}
